import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// Set the workerSrc to the correct path
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = ({ file, withPageNum = true, controls = true }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  const handlePrint = () => {
    const printWindow = window.open(file);
    printWindow?.addEventListener('load', () => {
      printWindow.focus();
      printWindow.print();
    });
  };

  return (
    <React.Fragment>
      {/* Control Icons */}
      {controls && (
        <div style={{ textAlign: 'center', marginBottom: 10 }}>
          <a href={file} download style={{ marginRight: 15 }}>
            📥 Download
          </a>
          <button onClick={handlePrint}>🖨️ Print</button>
        </div>
      )}

      {withPageNum && (
        <div style={{ margin: '20px 0', width: '100%', textAlign: 'center' }}>
          <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
            Previous
          </button>
          <span style={{ margin: '0 10px' }}>
            Page {pageNumber} of {numPages}
          </span>
          <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
            Next
          </button>
        </div>
      )}
      <div
        style={{
          maxWidth: 900,
          margin: '20px auto',
          marginTop: 30,
          border: '1px solid #999',
          position: 'relative',
        }}
      >
        <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page
            pageNumber={pageNumber}
            scale={2.0} // or just use width={600}, but not both
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      </div>
    </React.Fragment>
  );
};

export default PDFViewer;
